import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=9265cfbc&scoped=true&"
import script from "./CarInfo.vue?vue&type=script&lang=ts&"
export * from "./CarInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=9265cfbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9265cfbc",
  null
  
)

export default component.exports